export default [
  {
    path: "/flightResource",
    name: "flightResource",
    component: () => import('@/flightResource/pages/index.vue'),
    meta: {
      title: "首页搜索",
      layout: {
        navBar: {
          showNavBar: false,
          showLeftArrow: false,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
    children: []
  },
  {
    path: "/flightResource/query",
    name: "flightQuery",
    component: () => import('@/flightResource/pages/query/index.vue'),
    meta: {
      title: "航班查询",
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
    children: [],
  },
  {
    path: "/flightResource/orderDetail",
    name: "orderDetail",
    component: () => import('@/flightResource/pages/orderDetail/index.vue'),
    meta: {
      title: "订单详情",
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
    children: []
  },
  {
    path: "/flightResource/refundProcess",
    name: "refundProcess",
    component: () => import('@/flightResource/pages/orderDetail/refundProcess.vue'),
    meta: {
      title: "退票进度",
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
  },
  {
    path: "/flightResource/childOrderPolicy",
    name: "childOrderPolicy",
    component: () => import('@/flightResource/pages/orderDetail/childOrderPolicy.vue'),
    meta: {
      title: "儿童婴儿预订说明",
      layout: {
        navBar: {
          showNavBar: false,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
  },
  {
    path: '/flightResource/flightList',
    name: 'flightList',
    component: () => import('@/flightResource/pages/flightList/index.vue'),
    meta: {
      title: '机票列表',
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
      isKeepAlive: true,
    },
    children: [],
  },
  {
    path: "/flightResource/cabinList",
    name: "cabinList",
    component: () => import('@/flightResource/pages/cabinList/index.vue'),
    meta: {
      title: "舱位列表",
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
      isKeepAlive: true,
    },
    children: []
  },
  {
    path: "/flightResource/orderFill",
    name: "orderFill",
    component: () => import('@/flightResource/pages/orderFill/index.vue'),
    meta: {
      title: "填写订单",
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
      isKeepAlive: true,
    },
    children: []
  },
  {
    path: "/flightResource/agreementNotice",
    name: "agreementNotice",
    component: () => import('@/flightResource/pages/orderFill/AgreementNoticePage.vue'),
    meta: {
      title: "机票预订购票须知",
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
    children: []
  },
  {
    path: "/flightResource/passengerSave",
    name: "passengerSave",
    component: () => import('@/flightResource/pages/passenger/PassengerSave.vue'),
    meta: {
      title: "新增乘机人",
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
    children: []
  },
  {
    path: "/flightResource/orderList",
    name: "flightOrderList",
    component: () => import('@/flightResource/pages/orderList/index.vue'),
    meta: {
      title: "机票订单",
      isKeepAlive: true,
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
    children: []
  },
  {
    path: "/flightResource/refundApply",
    name: "refundApply",
    component: () => import('@/flightResource/pages/refundApply/index.vue'),
    meta: {
      title: "退票申请",
      layout: {
        navBar: {
          showNavBar: true,
          showLeftArrow: true,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
    children: []
  },
  {
    path: '/flightResource/flightPay',
    component: () => import('@/flightResource/pages/flightPay/index.vue'),
    name: 'flightPay',
    meta: {
      title: '机票支付',
      activeBar: 'order'
    },
  },
  {
    path: '/flightResource/citySelect',
    name: 'citySelect',
    component: () => import('@/flightResource/pages/citySelect/index.vue'),
    meta: {
      title: '城市选择',
      layout: {
        navBar: {
          showNavBar: false,
          showLeftArrow: false,
        },
        tabbar: {
          showTabbar: false,
        },
      },
    },
    children: []
  },
]
